(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .filter('filtroTabellaEsterni', filtroTabellaEsterni)
        .controller('EsterniController', EsterniController);

    EsterniController.$inject = ['$state','$scope', 'Esterni', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','EsterniStatiSpecService','CategorieService','SessionStorage'];

    
    //Filtro per ricerca Esterni
    function filtroTabellaEsterni() {
    	return function(dataArray, searchTerm, typeFilter, statoFilter) {
		      if (!dataArray) {
		          return;
		      }
		      else if (!searchTerm && !typeFilter && !statoFilter) {
		          return dataArray;
		      }
		      else {
		           
		           
		           return dataArray.filter(function(item){
		        	  var textCondition = true;
		        	  var typeCondition = true;
		        	  var statoCondition = true;
		        	  if(searchTerm!=null && searchTerm.length>0){
		        		  var text = searchTerm.toLowerCase();
		        		  var nameMatch = item.nome.toLowerCase().indexOf(text) > -1;
			              var surnameMatch = item.cognome.toLowerCase().indexOf(text) > -1;
			              var emailMatch = item.emailPrivata.toLowerCase().indexOf(text) > -1;
			              var userIdMatch = item.userId!=null ? (item.userId.toLowerCase().indexOf(text) > -1) : false;
			              var codFisMatch;
			              if(item.codiceFiscale!=null)
			            	  codFisMatch = item.codiceFiscale.toLowerCase().indexOf(text) > -1;
			              else
			            	  codFisMatch = item.documentoIdentita.toLowerCase().indexOf(text) > -1;
			            	  
			              textCondition = nameMatch || surnameMatch || emailMatch || codFisMatch || userIdMatch;
		        		  
		        	  }
		        	  if(typeFilter!=null && typeFilter.length>0){
		        		  var type = parseInt(typeFilter,10);
		        		  if(item.categoria!=null)
		        			  typeCondition = item.categoria.id===type;
		        	  }
		        	  if(statoFilter!=null && statoFilter.length>0){
		        		  var stato = parseInt(statoFilter,10);
		        		  if(item.statoSpecifico!=null)
		        			  statoCondition = item.statoSpecifico.id===stato;
		        	  }
		        	  
		        	  return textCondition && typeCondition && statoCondition;
		           });
		      } 
		  }    
    }
    
    
    function EsterniController($state, $scope, Esterni, ParseLinks, AlertService, paginationConstants, pagingParams,EsterniStatiSpecService,CategorieService,SessionStorage) {

		var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        //Tipologie e stati
        vm.tipologiePerFiltro = null;
        vm.statiSpecPerFiltro = null;
    	getCategorieList();
    	getStatiSpecificiList();
        
		$scope.esternis = [];
        $scope.page = 0;
        
        SessionStorage.init(vm, "UR1L.esterni", ["nameFilter", "typeFilter", "statusFilter"]);
        
        loadAll();
        
        $scope.chengeFilter = function() {
        	SessionStorage.saveAll(vm, "UR1L.esterni", ["nameFilter", "typeFilter", "statusFilter"]);
        	loadAll();
        }
        
        function getSort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }
        
        function getQueryParams() {
        	var params = {
        		page: pagingParams.page - 1,
            	size: vm.itemsPerPage,
            	sort: getSort()
            };
        	if (vm.nameFilter) {
        		params["search"] = vm.nameFilter;
        	}
        	if (vm.typeFilter) {
        		params["type"] = vm.typeFilter;
        	}
        	if (vm.statusFilter) {
        		params["status"] = vm.statusFilter;
        	}
        	return params;
        }
        
        function loadAll() {
        	
            Esterni.query(getQueryParams(), onSuccess, onError);
                        
            function onSuccess(data, headers) {
            	var filter = headers('FILTER-search');
            	if (filter == vm.nameFilter || (!filter && vm.nameFilter == '') ) {
            		console.log("showing results filtered for: " + filter);
            		vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    $scope.esternis = data;
            	} else {
            		console.log("filtering response not corresponding to actual query");
            	}
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        vm.activateUser = function(esterno,toActivate){
        	
        	
        	Esterni.activate({id: esterno.id, toActivate:toActivate},onSuccess,onError);
        	
        	function onSuccess(data, headers) {
        		esterno.flAttivo= toActivate ? 1 : 0;
        		esterno.statoSpecifico = data.statoSpecifico;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        
        function getCategorieList(){
        	CategorieService.external.get({}, function(resp) {
        		vm.tipologiePerFiltro = resp;
        	}, function(err) {
        		deferred.reject(false);
        	});
        };
        
        function getStatiSpecificiList(){
        	EsterniStatiSpecService.stati.getAll({}, function(resp) {
        		vm.statiSpecPerFiltro = resp;
        	}, function(err) {
        		deferred.reject(false);
        	});
        };
        
    }
})();